export const productos = [
    {
        id      : '1',
        title   : 'REQUERIMIENTOS.CERTIFICAR_C1.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR.TITULO',
        url : 'certify',
        category: 'CGO',
        length  : 30,
        updated : '9 Agosto 2019',
        start : 'WIZARD.CERTIFICAR.LANDING.ENTRAR'
    },
    {
        id      : 'c1',
        title   : 'REQUERIMIENTOS.CERTIFICAR_C1.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR_C1.TITULO',
        url : 'certify',
        category: 'CGO',
        length  : 30,
        updated : '9 Agosto 2019',
        start : 'WIZARD.CERTIFICAR_C1.LANDING.ENTRAR'
    },
    {
        id      : 'c2',
        title   : 'REQUERIMIENTOS.CERTIFICAR_C1.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR_C2.TITULO',
        url : 'certify',
        category: 'CGO',
        length  : 30,
        updated : '9 Agosto 2019',
        start : 'WIZARD.CERTIFICAR_C2.LANDING.ENTRAR'
    },
    {
        id      : 'c3',
        title   : 'REQUERIMIENTOS.CERTIFICAR_C1.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR_C3.TITULO',
        url : 'certify',
        category: 'CGO',
        length  : 30,
        updated : '9 Agosto 2019',
        start : 'WIZARD.CERTIFICAR_C3.LANDING.ENTRAR'
    },
    {
        id      : 'c6',
        title   : 'WIZARD.CERTIFICAR_C6.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.CERTIFICAR_C6.TITULO',
        url : 'certify',
        category: 'CGO',
        length  : 30,
        updated : '9 enero 2023',
        start : 'WIZARD.CERTIFICAR_C6.LANDING.ENTRAR'
    },
    {
        id      : '2',
        title   : 'WIZARD.MEDIR.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR.TITULO',
        url : 'measurement',
        category: 'Medir',
        length  : 30,
        updated : '26 Agosto 2019',
        start : 'WIZARD.MEDIR.LANDING.ENTRAR'
    },
    {
        id      : '3',
        title   : 'WIZARD.PULSE.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.PULSE.TITULO',
        url : 'pulse',
        category: 'Pulse',
        length  : 30,
        updated : '26 Agosto 2019',
        start : 'WIZARD.PULSE.LANDING.ENTRAR'
    },
    {
        id      : '4',
        title   : 'WIZARD.FOCUS.TITULO',
        welcome : 'WIZARD.LANDING.PRODUCTO.FOCUS.TITULO',
        url : 'focus',
        category: 'Focus',
        length  : 30,
        updated : '26 Agosto 2019',
        start : 'WIZARD.FOCUS.LANDING.ENTRAR'
    },
    {
      id      : 'm1',
      title   : 'WIZARD.MEDIR_M1.TITULO',
      welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR_M1.TITULO',
      url : 'measurement',
      category: 'Medir',
      length  : 30,
      updated : '26 Agosto 2019',
      start : 'WIZARD.MEDIR_M1.LANDING.ENTRAR'
    },
    {
      id      : 'm2',
      title   : 'WIZARD.MEDIR_M2.TITULO',
      welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR_M2.TITULO',
      url : 'measurement',
      category: 'Medir',
      length  : 30,
      updated : '26 Agosto 2029',
      start : 'WIZARD.MEDIR_M2.LANDING.ENTRAR'
    },
    {
      id      : 'm3',
      title   : 'WIZARD.MEDIR_M3.TITULO',
      welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR_M3.TITULO',
      url : 'measurement',
      category: 'Medir',
      length  : 30,
      updated : '26 Agosto 2039',
      start : 'WIZARD.MEDIR_M3.LANDING.ENTRAR'
    },
    {
      id      : 'm4',
      title   : 'WIZARD.MEDIR_M4.TITULO',
      welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR_M4.TITULO',
      url : 'measurement',
      category: 'Medir',
      length  : 30,
      updated : '26 Agosto 2049',
      start : 'WIZARD.MEDIR_M4.LANDING.ENTRAR'
    },
    {
      id      : 'm5',
      title   : 'WIZARD.MEDIR_M5.TITULO',
      welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR_M5.TITULO',
      url : 'measurement',
      category: 'Medir',
      length  : 30,
      updated : '26 Agosto 2059',
      start : 'WIZARD.MEDIR_M5.LANDING.ENTRAR'
    },
    {
      id      : 'm6',
      title   : 'WIZARD.MEDIR_M6.TITULO',
      welcome : 'WIZARD.LANDING.PRODUCTO.MEDIR_M6.TITULO',
      url : 'measurement',
      category: 'Medir',
      length  : 30,
      updated : '26 Agosto 2069',
      start : 'WIZARD.MEDIR_M6.LANDING.ENTRAR'
    },
];
